import {Box, Button, Dialog, DialogActions, DialogContent, DialogTitle, useTheme} from '@mui/material'
import React, {useEffect, useState} from 'react'
import {Recurrence} from '../../../domain/Recurrence'
import {GridRowModel} from '@mui/x-data-grid'
import {AddCircleRounded} from '@mui/icons-material'
import {RecurrenceDataGrid} from './RecurrenceDataGrid'
import {handleRecurrenceCreate, handleRecurrenceDelete, mapGridRowsToRecurrences, mapRecurrencesToGridRows} from './recurrenceRows'
import {useIsMobile} from '../../../utils/useIsMobile'
import {RecurrenceCardList} from './RecurrenceCardList'

type RecurrenceDialogProps = {
  isOpen: boolean,
  onClose: () => void,
  recurrences: Recurrence[],
  handleRecurrencesUpdate: (recurrences: Recurrence[]) => void,
}

export const RecurrenceDialog: React.FC<RecurrenceDialogProps> = ({isOpen, onClose, recurrences, handleRecurrencesUpdate}) => {
  const theme = useTheme()
  const isMobile = useIsMobile()
  const [rows, setRows] = useState<GridRowModel[]>(mapRecurrencesToGridRows(recurrences))

  useEffect(() => {setRows(mapRecurrencesToGridRows(recurrences))}, [recurrences])

  const onProcessRowUpdate = (updatedRow: GridRowModel) => {
    setRows(prev => prev.map(row => (row.id === updatedRow.id ? {...row, ...updatedRow} : row)))
    return updatedRow
  }
  const onAddRecurrence = () => setRows(handleRecurrenceCreate(rows))
  const onDeleteRecurrence = (id: string) => setRows(handleRecurrenceDelete(id, rows))
  const onSave = () => {handleRecurrencesUpdate(mapGridRowsToRecurrences(rows)); onClose()}
  const onDialogClose = () => {setRows(mapRecurrencesToGridRows(recurrences)); onClose()}

  return (
    <Dialog open={isOpen} onClose={onDialogClose} maxWidth="xl">
      <DialogTitle>
        <Box borderRadius={1} sx={{paddingLeft: 1, backgroundColor: theme.palette.recurrence.main, color: 'white'}}>Récurrences</Box>
      </DialogTitle>
      <Button startIcon={<AddCircleRounded/>} onClick={onAddRecurrence} color="recurrence" variant="contained" sx={{marginLeft: 'auto', marginRight: 4}}>Ajouter</Button>
      <DialogContent>
        {isMobile
          ? <RecurrenceCardList rows={rows} onProcessRowUpdate={onProcessRowUpdate} onDeleteRecurrence={onDeleteRecurrence}/>
          : <RecurrenceDataGrid rows={rows} onProcessRowUpdate={onProcessRowUpdate} onDeleteRecurrence={onDeleteRecurrence}/>}
      </DialogContent>
      <DialogActions>
        <Button onClick={onDialogClose} color="recurrence">Annuler</Button>
        <Button onClick={onSave} variant="contained" color="recurrence">Enregistrer</Button>
      </DialogActions>
    </Dialog>
  )
}
